/**
 * Whitelist of allowed domains for advertisement iframes
 * Only iframes from these domains will be allowed to load
 * 
 * SECURITY: Be very careful when adding new domains!
 * Only add domains from trusted advertising platforms.
 */

export const ALLOWED_AD_DOMAINS = [
    'pulsmedia.is',
    'www.pulsmedia.is',
    'google.com',
    'www.google.com',
    'googlesyndication.com',
    'www.googlesyndication.com',
    'doubleclick.net',
    'www.doubleclick.net',
    // Add more trusted domains here
];

/**
 * Checks if a URL is from an allowed domain
 * @param {string} url - The URL to check
 * @returns {boolean} - True if domain is allowed, false otherwise
 */
export const isAllowedAdDomain = (url) => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();
        
        // Check if hostname matches any allowed domain
        return ALLOWED_AD_DOMAINS.some(domain => {
            const lowerDomain = domain.toLowerCase();
            // Exact match or subdomain match
            return hostname === lowerDomain || hostname.endsWith('.' + lowerDomain);
        });
    } catch {
        return false;
    }
};

/**
 * Gets a formatted list of allowed domains for display
 * @returns {string} - Comma-separated list of domains
 */
export const getAllowedDomainsDisplay = () => {
    return ALLOWED_AD_DOMAINS.join(', ');
};
